"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboEntityInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const react_intl_1 = require("react-intl");
const notistack_1 = require("notistack");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const mui_page_layout_1 = require("@framework/mui-page-layout");
const provider_test_id_1 = require("@framework/provider-test-id");
const react_hooks_1 = require("@framework/react-hooks");
const ComboEntityInput = props => {
    const { name, controller, getTitle, targetId = "id", autoselect = false, data = {}, variant = "standard", onChange, registerInput, label, placeholder, disabled, readOnly, freeSolo = false, disableClear, } = props;
    const suffix = name.split(".").pop();
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const [open, setOpen] = (0, react_2.useState)(false);
    const form = (0, react_hook_form_1.useFormContext)();
    const error = (0, react_hook_form_1.get)(form.formState.errors, name);
    const value = (0, react_hook_form_1.useWatch)({ name });
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedLabel = label ?? formatMessage({ id: `form.labels.${suffix}` });
    const localizedPlaceholder = placeholder ?? formatMessage({ id: `form.placeholders.${suffix}` });
    const localizedHelperText = error ? formatMessage({ id: error.message }, { label: localizedLabel }) : "";
    const [options, setOptions] = (0, react_2.useState)([]);
    const abortController = new AbortController();
    const { fn: fetchByController, isLoading } = (0, react_hooks_1.useApiCall)((api, data) => {
        return api.fetchJson({
            url: `/${controller}/autocomplete`,
            data,
            signal: abortController.signal,
        });
    }, { success: false });
    const fetchOptions = (0, react_2.useCallback)(async () => {
        return fetchByController(form, data)
            .then((json) => {
            setOptions(json);
            if (autoselect) {
                const newValue = json[0];
                if (!newValue) {
                    form.setValue(name, null, { shouldDirty: true });
                    return;
                }
                const isValueNotExistInOptions = value && json.every((o) => o[targetId] !== value);
                if (!value || isValueNotExistInOptions) {
                    onChange
                        ? onChange({}, newValue, "autoselect")
                        : form.setValue(name, newValue[targetId], { shouldDirty: true });
                }
            }
        })
            .catch(e => {
            if (!e.message.includes("The user aborted a request")) {
                console.error(e);
                (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.error" }), { variant: "error" });
            }
        });
    }, [data, value, name, form]);
    (0, react_hooks_1.useDeepCompareEffect)(() => {
        void fetchOptions();
        return () => abortController.abort();
    }, [data]);
    (0, react_2.useEffect)(() => {
        const unregisterInput = registerInput && registerInput(name, true);
        return () => {
            unregisterInput && unregisterInput();
        };
    }, [name, registerInput]);
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: form.control, render: ({ field }) => {
            return ((0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { open: open, onOpen: () => !readOnly && setOpen(true), onClose: () => setOpen(false), disableClearable: disableClear || readOnly, sx: { my: 1 }, multiple: false, disabled: disabled, options: options, freeSolo: freeSolo, autoSelect: true, value: options.find((option) => value === option[targetId]) || null, onChange: onChange ||
                        ((_event, option, reason) => {
                            let value = option ? (typeof option !== "string" ? option[targetId] : option) : null;
                            if (reason === "blur" && typeof option === "string") {
                                const foundOption = options.find(({ title, address }) => option === title || option === address);
                                value = foundOption?.address || option;
                            }
                            form.setValue(name, value, { shouldDirty: true, shouldTouch: true });
                            void form.trigger(name);
                        }), getOptionLabel: (option) => getTitle ? getTitle(option) : typeof option !== "string" ? option.title : option, renderOption: (props, option) => {
                        const title = getTitle ? getTitle(option) : typeof option !== "string" ? option.title : option;
                        return ((0, react_1.createElement)("li", { ...props, key: typeof option !== "string" ? option.id : option }, title));
                    }, renderInput: (params) => ((0, jsx_runtime_1.jsx)(material_1.TextField, { ...params, ...field, inputProps: { ...params.inputProps, readOnly, ...testIdProps }, InputProps: { ...params.InputProps }, label: localizedLabel, placeholder: localizedPlaceholder, error: !!error, helperText: localizedHelperText, variant: variant, onChange: () => { }, onBlur: () => {
                            if (!readOnly) {
                                field.onBlur();
                            }
                        }, fullWidth: true })) }) }));
        } }));
};
exports.ComboEntityInput = ComboEntityInput;
//# sourceMappingURL=index.js.map